// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const it = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Home',
    search: 'Cerca',
    login: 'Accedi',
    register: 'Registrati',
    dashboard: 'Pannello',
    reservas: 'Prenotazioni',
    equipo: 'Team',
    logout: 'Esci',
    legal: 'Legale',
    legalNotice: 'Note legali',
    privacy: 'Informativa sulla privacy',
    cookies: 'Informativa sui cookie',
    terms: 'Termini e condizioni',
    clientes: 'Clienti',
  },
  legal: {
    noticeTitle: 'Note legali',
    noticeBody:
      'In conformità alla legge spagnola 34/2002 (LSSI-CE), si comunica che questo sito web è di proprietà di bitutravel. E-mail di contatto: legal@bitutravel.app. L\'utilizzo del sito attribuisce la qualità di utente e implica l\'accettazione delle presenti condizioni.',
    privacyTitle: 'Informativa sulla privacy',
    privacyBody:
      'Trattiamo i suoi dati esclusivamente per gestire il suo account, le sue prenotazioni e la fatturazione richiesta dalla normativa spagnola (GDPR e LOPDGDD). Non cediamo mai i suoi dati a terzi per finalità commerciali. Può esercitare i suoi diritti di accesso, rettifica, cancellazione e portabilità scrivendo a privacy@bitutravel.app.',
    cookiesTitle: 'Informativa sui cookie',
    cookiesBody:
      'bitutravel utilizza solo cookie tecnici strettamente necessari: la sessione di autenticazione e la preferenza linguistica. Non utilizziamo cookie pubblicitari né di tracciamento di terze parti.',
    termsTitle: 'Termini e condizioni',
    termsBody:
      'Le prenotazioni vengono richieste tramite la piattaforma e restano soggette all\'approvazione del proprietario e alla politica di cancellazione scelta. La fatturazione corporate viene emessa conformemente alla normativa spagnola (IVA e IRPF applicabili). bitutravel agisce come intermediario tra l\'azienda richiedente e il proprietario dell\'alloggio. I prezzi mostrati non includono l\'IVA (21%), aggiunta al totale della prenotazione.',
  },
  landing: {
    heroTitle: 'Alloggi corporate senza complicazioni',
    heroSubtitle:
      'Trovate alloggi di qualità per soggiorni di media durata per i vostri team in tutta la Spagna. Con la fiducia delle aziende leader.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Ospiti',
    search: 'Cerca',
    featured: 'Soggiorni in evidenza',
    featuredIn: 'In evidenza a {{city}}',
    guestsValue: '{{count}} ospiti',
    where: 'Dove',
    when: 'Quando',
    who: 'Chi',
    searchDestinations: 'Cerca destinazioni',
    addDates: 'Aggiungi date',
    addGuests: 'Aggiungi ospiti',
    howItWorks: 'Come funziona',
    step1Title: 'Cerca',
    step1Desc: 'Esplora gli alloggi verificati nelle principali città della Spagna.',
    step2Title: 'Prenota',
    step2Desc: 'Prenota soggiorni di media durata per i tuoi team a condizioni corporate.',
    step3Title: 'Trasferitevi',
    step3Desc: 'Il tuo team si trasferisce. Noi gestiamo fattura e nota spese del viaggiatore.',
    perNight: '/ notte',
    perNightPlusIva: '/ notte + IVA',
    comingSoon: 'Prossimamente',
    trustedBy: 'Già si fidano di noi',
    testimonialsTitle: 'Cosa dicono i nostri clienti',
    review1Text: 'Da quando uso bitutravel le fatture ci arrivano e semplifica tutto il processo.',
    review1Author: 'María López',
    review1Role: 'Responsabile mobilità, società di consulenza tech',
    review2Text: 'Gestiamo l\'alloggio di tutto il team su un\'unica piattaforma. Il risparmio di tempo e costi è evidente.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Direttore operativo, società di ingegneria',
    review3Text: 'La fatturazione aziendale e la nota spese del viaggiatore arrivano pronte per l\'audit. Zero lavoro amministrativo.',
    review3Author: 'Elena García',
    review3Role: 'Responsabile finanziario, multinazionale',
    illustrativeImage: 'immagine illustrativa',
  },
  search: {
    allSpain: 'Tutta la Spagna',
    allDistricts: 'Tutti i distretti',
    viewAllResults: 'Vedi tutti i risultati',
    results: 'risultati',
    sort: 'Ordina',
    sortPriceAsc: 'Prezzo: crescente',
    sortPriceDesc: 'Prezzo: decrescente',
    noResults: 'Nessun alloggio in questa zona.',
    noResultsForFilters:
      'Nessun alloggio per questi filtri. Prova a rimuovere le date o a modificare i filtri.',
    clearFilters: 'Rimuovi filtri',
    areaPlaceholder: 'Quartiere, zona o codice postale',
    showMap: 'Mappa',
    showMore: 'Vedi di più',
    backToTop: 'Torna su',
    typeAll: 'Tutto',
    placeEntire: 'Appartamento intero',
    placeRoom: 'Camera privata',
    placeHotel: 'Hotel',
    dates: 'Date',
    sortRecommended: 'Consigliato',
    size: 'Camere',
    sizeAny: 'Qualsiasi',
    sizeSingle: '1 camera',
    sizeDouble: '2 camere',
    size3plus: '3+ camere',
    rooms: 'Camere da letto',
    units: 'Unità',
    grouping: 'Raggruppa',
    groupAny: 'Qualsiasi',
    typeInCity: '{{type}} a {{city}}',
    forNights: 'per {{count}} notti',
    filters: 'Filtri',
    groupSameBuilding: 'Stesso edificio',
    groupSameArea: 'Zona più vicina',
    groupSameCategory: 'Stessa categoria',
    roomsValue: '{{count}} cam.',
    unitsValue: '{{count}} u.',
    groupResults: 'gruppi',
    fromPrice: 'da {{price}}',
    unitsInBuilding: '{{count}} alloggi in questo edificio',
    groupUnits: 'unità',
    sameBuilding: 'Stesso edificio',
    sameArea: 'Zona più vicina',
    sameCategory: 'Stessa categoria',
    anyGroup: 'Unità',
    priceFrom: 'da',
    bookAll: 'Prenota tutte le {{count}}',
    playTour: 'Riproduci tour',
    approxMapNote: 'Le posizioni sono approssimative. Accedi per vedere la posizione esatta.',
    pauseTour: 'Metti in pausa il tour',
    bookAllTitle: 'Prenota il gruppo',
    bookAllDesc: 'Prenota le {{count}} unità come un unico complesso.',
    bookAllSummary: '{{count}} unità · {{nights}} notti',
    bookAllSomeFailed: 'Alcune unità non hanno potuto essere prenotate.',
    bookAllDone: 'Gruppo prenotato ({{ok}}/{{count}}).',
    structRoomIn: 'Stanza a {{building}}',
    structRoomsSameApartment: '{{count}} stanze nello stesso appartamento',
    structRoomsSameBuilding: '{{count}} stanze nello stesso edificio',
    structApartmentsSameBuilding: '{{count}} appartamenti nello stesso edificio',
    structStaysSameArea: '{{count}} alloggi nella stessa zona',
    structStaysSameCategory: '{{count}} alloggi · {{category}}',
    structUnits: '{{count}} unità',
    specFull: '{{guests}} ospiti · {{bedrooms}} camere · {{baths}} bagni',
    specShort: '{{bedrooms}} cam. · {{baths}} bagno',
  },
  detail: {
    guests: 'ospiti',
    bedrooms: 'camere da letto',
    bathrooms: 'bagni',
    amenities: 'Servizi',
    location: 'Posizione',
    nights: 'notti',
    cleaningFee: 'Pulizia',
    total: 'Totale',
    iva: 'IVA ({{pct}}%)',
    ivaNote: 'Prezzi senza IVA: il 21% di IVA viene aggiunto al totale della prenotazione. Fattura aziendale conforme.',
    bookNow: 'Prenota ora',
    loginToBook: 'Accedi per prenotare',
    signInForDetails: 'Accedi per vedere i dettagli completi.',
    approxLocation: 'Posizione approssimativa (raggio ~700 m)',
    checkin: 'Check-in',
    checkout: 'Check-out',
    tooManyGuests: 'Questa proprietà ospita fino a {{capacity}} ospiti.',
    minStayWarning: 'Soggiorno minimo: {{count}} notte | Soggiorno minimo: {{count}} notti',
    nightsWithCount: '{{count}} notte | {{count}} notti',
  },
  booking: {
    title: 'Prenota ora',
    subtitle: 'Verifichi i dati del viaggiatore. L\'importo viene ricalcolato sul server.',
    confirm: 'Conferma prenotazione',
    guestName: 'Nome del viaggiatore',
    guestNamePlaceholder: 'Nome e cognome',
    guestNif: 'NIF del viaggiatore',
    datesRequired: 'Selezioni date valide',
    nameRequired: 'Inserisca il nome del viaggiatore',
    nifInvalid: 'NIF non valido',
    requestCreated: 'Prenotazione creata. In attesa di pagamento.',
    notAvailable: 'Queste date non sono più disponibili.',
    notApproved: 'Il suo account non è approvato per prenotare.',
    createError: 'Impossibile creare la prenotazione. Riprovi.',
    awaitingDesc: 'Prenotazione creata. Effettui il pagamento per confermarla.',
    totalWithIva: 'Totale (IVA inclusa)',
    priceEstimateNote: 'Prezzo stimato: l\'importo finale è calcolato da bitutravel al momento della prenotazione.',
    total: 'Totale',
    reference: 'Riferimento',
    openPaymentLink: 'Apri link di pagamento',
    mockDevNote:
      'Modalità sviluppo: il pagamento è simulato. Faccia clic per contrassegnare come pagato e simulare il webhook di Revolut.',
    markPaidDev: 'Contrassegna come pagato (dev)',
    markPaidError: 'Impossibile simulare il pagamento.',
    paid: 'Pagamento confermato',
    paidDesc: 'La sua prenotazione è confermata. Riceverà la fattura via email.',
    viewBookings: 'Vedi le mie prenotazioni',
    paymentStatus: 'Pagamento',
    bookingsTitle: 'Le mie prenotazioni',
    browseStays: 'Cerca alloggio',
    summaryTotal: 'Prenotazioni',
    summaryUpcoming: 'Prossime',
    summaryInstay: 'In soggiorno',
    summarySpend: 'Spesa totale',
    summaryPendingNote: 'Hai {{count}} prenotazioni in attesa di pagamento.',
    payStatusPaid: 'Pagato',
    payStatusPending: 'In attesa',
    payStatusAwaiting: 'In attesa di pagamento',
    payStatusRefunded: 'Rimborsato',
    payStatusFailed: 'Fallito',
    payStatusScheduled: 'Programmato',
    empty: 'Non ha ancora prenotazioni.',
    statusAwaitingPayment: 'In attesa di pagamento',
    statusConfirmed: 'Confermata',
    statusActive: 'In corso',
    statusCompleted: 'Completata',
    statusCancelled: 'Annullata',
    statusDisputed: 'In contestazione',
    notFound: 'Prenotazione non trovata.',
    viewProperty: 'Vedi proprietà',
    cleaningFee: 'Pulizia',
    platformFee: 'Commissione bitutravel',
    cancelBooking: 'Annulla prenotazione',
    cancelConfirm:
      'Vuole davvero annullare questa prenotazione? L\'operazione non può essere annullata.',
    cancelConfirmYes: 'Sì, annulla',
    cancelledToast: 'Prenotazione annullata.',
    cancelError: 'Impossibile annullare la prenotazione.',
    cancelReason: 'Motivo della cancellazione',
    copyLink: 'Copia link',
    tabFuture: 'Prossime',
    tabPresent: 'In corso',
    tabPast: 'Passate',
    emptyTab: 'Nessuna prenotazione in questa sezione.',
    purpose: 'Motivo del viaggio',
    purposeLeisure: 'Personale',
    purposeConference: 'Convegno / evento',
    purposeProject: 'Progetto',
    purposeRelocation: 'Ricollocazione',
    purposeOther: 'Altro',
    eventName: 'Nome dell\'evento',
    eventNamePlaceholder: 'es. Mobile World Congress 2026',
    teamSize: 'Persone',
    teamNotes: 'Dettagli del team',
    teamNotesPlaceholder: 'Nomi dei viaggiatori, stanza, note…',
    teamDetails: 'Dettagli del viaggio / team',
    employee: 'Dipendente',
    employeePlaceholder: 'Non assegnato',
    employeeNone: 'Nessun dipendente',
    employeeFilterAll: 'Tutti i dipendenti',
    employeeCardTitle: 'Dipendente assegnato',
  },
  team: {
    title: 'Team',
    addEmployee: 'Aggiungi dipendente',
    intro: 'Gestisci i dipendenti della tua azienda. Assegnali alle prenotazioni per ricevere i dettagli per email, o attivali per fare le proprie prenotazioni a carico dell\'azienda.',
    featureRosterTitle: 'Elenco dipendenti',
    featureRosterDesc: 'Nome, email, telefono e NIF di ogni dipendente. La maggior parte sono ricorrenti: riutilizzabili tra prenotazioni.',
    featureEmailTitle: 'Dettagli per email',
    featureEmailDesc: 'Prenotando, assegni il dipendente che riceve i dati del soggiorno per email.',
    featureActivateTitle: 'Attiva per prenotare',
    featureActivateDesc: 'Attiva un dipendente per farlo entrare con la sua email e prenotare a carico dell\'azienda.',
    empty: 'Nessun dipendente ancora. Potrai presto aggiungerli e assegnarli alle prenotazioni.',
    editEmployee: 'Modifica dipendente',
    editDesc: 'Aggiorna i dati di contatto del dipendente.',
    addDesc: 'Aggiungi un dipendente e attivalo per accedere con la propria email.',
    addNote: 'Il dipendente viene aggiunto all\'elenco. Per fargli accedere con la sua email, attiva l\'accesso in seguito.',
    activateLogin: 'Attiva accesso',
    alreadyActivated: 'Questo dipendente ha già l\'accesso attivo.',
    platformUnavailable: 'Il servizio non è disponibile ora. Riprova più tardi.',
    phone: 'Telefono',
    updated: 'Dipendente aggiornato.',
    added: 'Dipendente aggiunto.',
    emailExists: 'Esiste già un dipendente con questa email.',
    activated: 'Dipendente attivato.',
    deactivated: 'Dipendente disattivato.',
    deleted: 'Dipendente eliminato.',
    activate: 'Attiva',
    deactivate: 'Disattiva',
    delete: 'Elimina',
    deleteTitle: 'Elimina dipendente',
    deleteConfirm: 'Vuoi davvero eliminare {{name}}? Il suo account verrà rimosso e non potrà essere annullato.',
    statusActive: 'Attivo',
    statusInactive: 'Inattivo',
    statusRoster: 'Solo elenco',
    tempPwTitle: 'Password temporanea',
    tempPwDesc: 'Questa è la password temporanea di {{name}}. Condividila in modo sicuro.',
    tempPwWarn: 'Non verrà più mostrata. Copiala ora.',
    copy: 'Copia',
    copied: 'Copiato',
  },
  agency: {
    title: 'Clienti',
    intro: 'Gestisci le aziende clienti della tua agenzia. Aggiungile con la loro email di fatturazione e prenota viaggi per loro conto — la fattura va all\'azienda cliente.',
    addClient: 'Aggiungi azienda cliente',
    clientEmail: 'Email di fatturazione dell\'azienda',
    clientEmailPlaceholder: 'fatture@azienda.it',
    addNote: 'L\'azienda deve avere un account bitutravel ed essere approvata. Viene verificata al collegamento.',
    empty: 'Non hai ancora aziende clienti. Aggiungine una per prenotare per suo conto.',
    client: 'Cliente',
    unknownClient: 'Azienda cliente',
    unlinkConfirm: 'Vuoi davvero scollegare {{name}}? Non potrai più prenotare per suo conto.',
    unlinkedBtn: 'Scollega',
    unlinked: 'Azienda cliente scollegata.',
    linked: 'Azienda cliente collegata: {{name}}.',
    notFound: 'Nessuna azienda approvata trovata con questa email.',
    billTo: 'Prenota per',
    selectClient: 'Seleziona un\'azienda cliente',
    noClientsWarn: 'Aggiungi prima un\'azienda cliente in Clienti per poter prenotare.',
  },

  invoices: {
    title: 'Fatture e note spese',
    backToBookings: '← Le mie prenotazioni',
    count: 'Fatture',
    baseTotal: 'Base imponibile',
    ivaTotal: 'IVA',
    irpfTotal: 'IRPF trattenuto',
    total: 'Totale fatturato',
    invoicesTitle: 'Fatture',
    ref: 'Prenotazione',
    parteTitle: 'Note spese del viaggiatore',
    parteEmpty: 'Ancora nessuna nota spese.',
    empty:
      'Non ha ancora fatture. Vengono generate automaticamente alla conferma di una prenotazione.',
    regenTitle: 'Reemettere i documenti',
    regenDesc:
      'Rigenera la fattura e la nota spese del viaggiatore di una prenotazione (utile per la contabilità).',
    regenDone: 'Documenti rigenerati.',
    regenError: 'Impossibile rigenerare i documenti.',
    downloadError: 'Impossibile scaricare il documento.',
    navInvoices: 'Fatture',
    period30: 'Ultimi 30 giorni',
    period90: 'Ultimi 90 giorni',
    period365: 'Ultimi 12 mesi',
    periodAll: 'Tutto lo storico',
    periodEmpty: 'Nessuna fattura in questo periodo.',
    exportCsv: 'Esporta CSV',
    exportZip: 'Scarica PDF (ZIP)',
    statusIssued: 'Emessa',
    statusPaid: 'Pagata',
    statusVoid: 'Annullata',
  },
  owner: {
    calendar: {
      title: 'Calendario tariffe',
      subtitle: 'Prezzo, soggiorno minimo e disponibilità notte per notte',
      navButton: 'Tariffe',
      backendRequired: 'Configura il backend Supabase per usare il calendario tariffe.',
      basePrice: 'Tariffa base',
      cleaningFee: 'Pulizia',
      applyTitle: 'Applica alla selezione',
      clearSelection: 'Cancella selezione',
      selectHint: 'Fai clic su una notte e poi su un’altra per selezionare un intervallo. Ogni cella è una notte — l’ultima segnata è la notte precedente al check-out.',
      selectedNights: '{{count}} notte selezionata | {{count}} notti selezionate',
      skipped: '{{count}} notte ignorata (prenotata o passata) | {{count}} notti ignorate (prenotate o passate)',
      noneEditable: 'Tutte le notti selezionate sono già prenotate o passate.',
      priceLabel: 'Nuovo prezzo (€)',
      pricePlaceholder: '€ / notte',
      minNightsLabel: 'Soggiorno minimo (notti)',
      minNightsPlaceholder: 'es. 5',
      applyPrice: 'Imposta prezzo',
      applyMinNights: 'Imposta minimo',
      block: 'Blocca',
      unblock: 'Apri',
      removeOverride: 'Rimuovi personalizzazione',
      blockNameLabel: 'Nome del blocco',
      blockNamePlaceholder: 'es. Manutenzione, Lavori…',
      saved: 'Calendario aggiornato',
      saveError: 'Impossibile salvare il calendario.',
      legend: {
        available: 'Disponibile',
        priced: 'Prezzo personalizzato',
        blocked: 'Bloccata',
        booked: 'Prenotata',
        past: 'Passata',
        sunday: 'Domenica',
      },
      ical: {
        title: 'Esporta calendario (iCal)',
        desc: 'Collega questo feed ad Airbnb, Booking.com o al tuo channel manager per sincronizzare le prenotazioni.',
        copy: 'Copia',
        copied: 'Link copiato',
        unavailable: 'Feed non disponibile per questa proprietà.',
      },
      bulk: {
        from: 'Dal',
        to: 'al',
        allDays: 'Tutti i giorni',
        weekdays: 'Giorni feriali',
        weekends: 'Weekend',
        allYear: 'Tutto l’anno',
        pickDay: 'Seleziona almeno un giorno della settimana',
      },
    },
    revenueTitle: 'Ricavi',
    invoicesTitle: 'Fatture e incassi',
    invoicesNote: 'Le fatture vengono generate automaticamente alla conferma di una prenotazione; i pagamenti sono regolati secondo il calendario bitutravel.',
    gross: 'Base (senza IVA)',
    fee: 'Commissione bitutravel',
    iva: 'IVA',
    net: 'Ricavo netto',
    paidOut: 'Pagato',
    pending: 'In attesa di pagamento',
    monthlyTitle: 'Ricavi per mese',
    perPropertyTitle: 'Per proprietà',
    property: 'Proprietà',
    bookings: 'Prenotazioni',
    nights: 'Notti',
    payoutsTitle: 'Pagamenti al proprietario',
    eligibleDesc: 'Prenotazioni confermate pronte per il pagamento:',
    payNow: 'Paga',
    scheduled: 'Programmato',
    noPayouts: 'Ancora nessun pagamento.',
    noData: 'Ancora nessun dato.',
    payoutDone: 'Pagamento emesso.',
    payoutError: 'Impossibile emettere il pagamento.',
    range7: '7 g',
    range15: '15 g',
    range30: '30 g',
    range90: '90 g',
    range12m: '12 m',
    rangeAll: 'Tutto',
    payoutConfirmTitle: 'Conferma pagamento',
    payoutConfirmDesc: 'Emettere il pagamento della prenotazione #{{id}} per {{amount}}?',
    confirm: 'Conferma',
    propertiesNav: 'Calendario',
    propertiesTitle: 'Calendario',
    newProperty: 'Aggiungi proprietà',
    editProperty: 'Modifica',
    propertyUntitled: 'Proprietà senza titolo',
    propertiesEmpty: 'Non ha ancora pubblicato nessuna proprietà.',
    pendingReviewNote:
      'Le nuove proprietà restano in revisione finché il team di bitutravel non le approva. La avviseremo via e-mail.',
    pendingEditorNote:
      'Questa proprietà è in revisione. Potrà modificarla; apparirà nella ricerca quando sarà approvata.',
    unpublished: 'Non pubblicata',
    photoCount: '{{count}} foto',
    noPhotos: 'Nessuna foto',
    unitCount: '{{count}} unità',
    viewCalendar: 'Calendario',
    viewList: 'Elenco',
    searchUnits: 'Cerca unità…',
    sortName: 'Nome',
    sortRecent: 'Recenti',
    chipNeedsPhotos: 'Senza foto',
    stripNoBookings: 'Nessuna prenotazione nei prossimi 30 giorni',
    pms: {
      title: 'Gestore prenotazioni',
      subtitle: 'Prenotazioni per unità — trascina per spostare',
      prev: 'Precedente',
      next: 'Successivo',
      today: 'Oggi',
      view_month: 'Mese',
      view_week: 'Settimana',
      dragHint: "Trascina una prenotazione in un'altra unità o data per spostarla.",
      moved: 'Prenotazione spostata',
      moveError: 'Impossibile spostare la prenotazione',
      noCity: 'Nessuna città',
      cities: 'Città',
      properties: 'Proprietà',
      unit: 'Unità',
      overall: 'Panoramica',
      allProperties: 'Tutte le proprietà',
      noUnits: 'Nessuna unità ancora. Aggiungi una proprietà per iniziare.',
      guest: 'Ospite',
      dragHintBlocked: "Click an empty day to block / open it. Drag a booking to move it; drag its right edge to extend or shorten.",
      addBooking: "Add booking",
      dates: 'Date',
      autoRate: 'Tariffa automatica',
      applyCustomPrice: 'Applica prezzo personalizzato (sconto)',
      customPriceHint: 'Modifica il totale per applicare uno sconto. Viene ripartito tra le notti.',
      manualBooking: "Manual booking",
      manualBadge: "Manual",
      guestName: "Guest name",
      guestNif: "Guest NIF",
      guests: "Guests",
      pricePerNight: "Prezzo per notte",
      checkin: "Check-in",
      checkout: "Check-out",
      block: "Block",
      unblock: "Open",
      blocked: "Blocked",
      blockTitle: 'Blocca notte',
      blockNameLabel: 'Nome (facoltativo)',
      blockNamePlaceholder: 'es. Manutenzione',
      blockNameHint: 'Mostrato sul giorno bloccato.',
      blockConfirm: 'Blocca',
      manualCreated: "Manual booking created",
      manualError: "Could not create manual booking",
      notAvailable: "Not available for those dates",
      belowMinStay: "Below the minimum stay for this unit",
      detail: "Booking detail",
      property: "Property",
      nights: "Nights",
      total: "Total",
      iva: "VAT",
      fee: "Platform fee",
      payout: "Payout",
      channel: "Channel",
      status: "Status",
      statusConfirmed: "Confirmed",
      statusActive: "In stay",
      statusPending: "Pending",
      statusAwaiting: "Awaiting payment",
      statusCancelled: "Cancelled",
      channelManual: "Manual",
      channelDirect: "Direct",
      channelIcal: "iCal (importato)",
      icalNoPayout: "Blocco esterno — nessun pagamento",
      confirmMove: "Confirm move",
      moveFrom: "From",
      moveTo: "To",
      moveNote: "Availability and price are revalidated on confirm.",
      confirm: "Confirm",
      extendTitle: "Extend stay",
      shortenTitle: "Shorten stay",
      newCheckout: "New check-out",
      extended: "Stay updated",
      extendError: "Could not update the stay",
    },
    products: {
      nav: 'Proprietà',
      title: 'Proprietà',
      subtitle: 'Tariffe e canali per unità. La tariffa predefinita si sincronizza con il prezzo della proprietà.',
      empty: 'Non hai ancora proprietà.',
      ratePlans: 'Tariffe',
      addRatePlan: 'Aggiungi tariffa',
      editRatePlan: 'Modifica tariffa',
      ratePlanDesc: 'Una tariffa è un’offerta vendibile di questa unità (prezzo, pulizia, soggiorno minimo).',
      noPlans: 'Nessuna tariffa ancora.',
      planCount: '{{count}} tariffe',
      icalCount: '{{count}} iCal',
      default: 'Predefinita',
      inactive: 'Inattiva',
      minNights: 'min. {{count}} notti',
      minNightsLabel: 'Notti minime',
      feePct: 'commissione {{pct}}%',
      feePctLabel: 'Commissione bitutravel (%)',
      feePctPlaceholder: 'predefinita',
      feePctHint: 'Vuoto = commissione globale. 0 = cliente portato (nessuna commissione).',
      makeDefault: 'Tariffa predefinita',
      name: 'Nome',
      basePrice: 'Prezzo base (NET)',
      cleaningFee: 'Pulizia',
      cancellation: 'Cancellazione',
      policy: {
        flexible: 'Flessibile',
        moderate: 'Moderata',
        strict: 'Rigida',
      },
      save: 'Salva',
      cancel: 'Annulla',
      edit: 'Modifica',
      delete: 'Elimina',
      confirmDelete: 'Elimina?',
      defaultNoDelete: 'La tariffa predefinita non può essere eliminata.',
      created: 'Tariffa creata.',
      updated: 'Tariffa aggiornata.',
      deleted: 'Tariffa eliminata.',
      channels: 'Canali',
      addChannel: 'Aggiungi canale',
      direct: 'Diretto',
      noConnections: 'Nessuna connessione. Aggiungi un canale iCal per importare un calendario esterno.',
      icalChannel: 'iCal',
      addIcal: 'Aggiungi connessione iCal',
      icalDesc: 'Incolla l’URL iCal di un calendario esterno (Airbnb, Booking, Google…). Le date prenotate bloccheranno questa unità.',
      icalUrl: 'URL del calendario iCal',
      addAndSync: 'Aggiungi e sincronizza',
      syncNow: 'Sincronizza',
      syncAll: 'Sincronizza tutto',
      syncDone: '{{upserted}} importate, {{cancelled}} cancellate, {{conflicts}} conflitti',
      syncAllDone: 'Sincronizzazione completa: {{upserted}} importate, {{cancelled}} cancellate, {{conflicts}} conflitti',
      syncError: 'Errore di sincronizzazione',
      lastSync: 'Ultima sincronizzazione',
      neverSynced: 'Non ancora sincronizzato',
      connectionDeleted: 'Connessione eliminata.',
      connStatus: {
        pending: 'In attesa',
        active: 'Attiva',
        paused: 'In pausa',
        error: 'Errore',
      },
      rangeActionTitle: 'Intervallo selezionato',
      rangeActionHint: 'Cosa vuoi fare con queste notti?',
      selectHint: 'Clicca su una notte e poi su un’altra (o due volte sulla stessa) per scegliere un intervallo.',
    },

    status: {
      pending: 'In revisione',
      approved: 'Pubblicato',
      rejected: 'Rifiutata',
    },
    step1: 'Dati',
    step2: 'Descrizione',
    step3: 'Posizione e foto',
    backStep: 'Indietro',
    nextStep: 'Avanti',
    saveProperty: 'Salva proprietà',
    fieldType: 'Tipo di alloggio',
    type: {
      apartment: 'Appartamento',
      studio: 'Monolocale',
      house: 'Casa',
      room: 'Camera',
      loft: 'Loft',
      duplex: 'Duplex',
      cabin: 'Cabin',
      guesthouse: 'Casa per ferie',
      hotel: 'Hotel',
      bed_breakfast: 'Bed & breakfast',
    },
    fieldCapacity: 'Capacità (ospiti)',
    fieldBeds: 'Letti',
    fieldPrice: 'Prezzo per notte (€)',
    fieldCleaning: 'Tariffa di pulizia (€)',
    fieldCheckinTime: 'Ora di check-in',
    fieldCheckoutTime: 'Ora di check-out',
    fieldTitleEs: 'Titolo (spagnolo)',
    fieldTitleEn: 'Titolo (inglese)',
    fieldDescEs: 'Descrizione (spagnolo)',
    fieldDescEn: 'Descrizione (inglese)',
    fieldCity: 'Città',
    fieldCategory: 'Categoria',
    fieldCategoryHint: 'executive, standard, suite…',
    fieldBuilding: 'Edificio / indirizzo',
    fieldUnitLabel: 'Etichetta dell\'unità',
    fieldNeighborhood: 'Quartiere / distretto',
    fieldNeighborhoodHint: 'es. Chamberí',
    fieldPostalCode: 'Codice postale',
    cityPrefillNote:
      'Scegliendo la città compiliamo le coordinate con il centro; le modifichi se conosce la posizione esatta.',
    photosAfterCreate: 'Salvi la proprietà per poter aggiungere le foto.',
    addPhotos: 'Aggiungi foto',
    deletePhoto: 'Elimina foto',
    photoUploadError: 'Impossibile caricare la foto.',
    photoDeleteError: 'Impossibile eliminare la foto.',
    createdToast: 'Proprietà creata. È in revisione.',
    savedToast: 'Proprietà salvata.',
    saveError: 'Impossibile salvare la proprietà.',
    fiscal: {
      title: 'Dati fiscali & VeriFactu',
      subtitle: 'Dati emittente e autorizzazione affinché bitutravel trasmetta le tue fatture all’AEAT.',
      statusActive: 'VeriFactu attivo. Le tue fatture di alloggio sono trasmesse all’AEAT.',
      statusPending: 'VeriFactu in attesa. Le tue fatture sono emesse ma non trasmesse all’AEAT.',
      statusRevoked: 'La tua autorizzazione è stata revocata. La trasmissione all’AEAT è sospesa.',
      active: 'Attivo',
      pending: 'In attesa',
      revoked: 'Revocato',
      issuerTitle: 'Dati emittente',
      personaType: 'Tipo di persona',
      personaF: 'Fisica',
      personaJ: 'Giuridica',
      seriesLodging: 'Serie fatture',
      seriesHint: 'Serie AEAT per le tue fatture di alloggio (predefinita O). Non cambiarla senza motivo.',
      legalName: 'Ragione sociale / Nome',
      nif: 'NIF',
      country: 'Paese',
      street: 'Indirizzo',
      postalCode: 'CAP',
      city: 'Città',
      save: 'Salva dati fiscali',
      saved: 'Dati fiscali salvati.',
      saveError: 'Impossibile salvare i dati fiscali.',
      errFields: 'Ragione sociale e NIF sono obbligatori.',
      apoderamientoTitle: 'Procura',
      apoderamientoDesc: 'Per trasmettere fatture all’AEAT per tuo conto, bitutravel necessita di una procura firmata. Carica la procura firmata per attivare la trasmissione.',
      poderOnFile: 'Procura registrata:',
      uploadPoder: 'Carica procura firmata (PDF)',
      poderHint: 'PDF, max 10 MB.',
      granted: 'Procura attivata. VeriFactu trasmetterà le tue prossime fatture.',
      grantError: 'Impossibile registrare la procura.',
      errPoderSize: 'Il file supera i 10 MB.',
      legalNote: 'Caricando la procura confermi di aver firmato l’autorizzazione di rappresentanza affinché bitutravel trasmetta fatture all’AEAT (RD 1007/2023).',
      bannerPending: 'Attiva VeriFactu per trasmettere le tue fatture all’AEAT.',
      bannerRevoked: 'La tua autorizzazione VeriFactu è revocata.',
      bannerCta: 'Configura',
    },

  },
  profile: {
    title: 'Profilo e impostazioni',
    navProfile: 'Profilo',
    accountSection: 'Account',
    statusLabel: 'Stato dell\'account',
    rejectionReason: 'Motivo del rifiuto',
    detailsSection: 'Dati fiscali',
    languageSection: 'Lingua',
    localeLabel: 'Lingua preferita',
    localeHint: 'Viene salvata nel suo account e applicata su tutti i suoi dispositivi.',
    localeSaved: 'Lingua aggiornata.',
    billingSection: 'Fatturazione e pagamento',
    invoiceEmail: 'Email di fatturazione',
    invoiceEmailPlaceholder: 'fatture@azienda.it',
    ibanTransfer: 'IBAN (pagamento tramite bonifico)',
    ibanHint: 'Se preferisci pagare tramite bonifico bancario.',
    preferredMethod: 'Metodo di pagamento preferito',
    methodCard: 'Carta',
    methodTransfer: 'Bonifico',
    savedCards: 'Carte salvate',
    defaultCard: 'Predefinita',
    billingProcessorNote: 'I dati della carta sono tokenizzati con Revolut; non memorizziamo mai il numero completo.',
    billingSaved: 'Fatturazione aggiornata.',
  },
  auth: {
    registerTitle: 'Crea account',
    loginTitle: 'Accedi',
    rolePrompt: 'Come utilizzerà bitutravel?',
    roleBook: 'Prenoto soggiorni',
    roleList: 'Pubblico proprietà',
    roleCompany: 'Azienda',
    roleAutonomo: 'Autonomo',
    roleOwner: 'Proprietario',
    roleEmployeeLabel: 'Dipendente',
    roleAgencyLabel: 'Agenzia',
    roleCompanyDesc: 'Prenotazioni centralizzate per la tua azienda',
    roleAutonomoDesc: 'Per professionisti autonomi',
    roleOwnerDesc: 'Per pubblicare e monetizzare le sue proprietà',
    roleBookerPrompt: 'Chi prenota?',
    pathManager: 'Gestisco proprietà',
    pathManagerDesc: 'Pubblica il tuo inventario e gestisci tariffe e disponibilità',
    pathBook: 'Prenoto soggiorni',
    pathBookDesc: 'Per aziende, dipendenti e liberi professionisti',
    roleEmployee: 'Lavoro in un’azienda',
    roleEmployeeDesc: 'Prenoto con la carta aziendale; la fattura va all’azienda',
    contactName: 'Persona di contatto',
    email: 'Email',
    fullName: 'Nome completo',
    legalName: 'Ragione sociale',
    cif: 'CIF',
    nif: 'NIF / DNI',
    address: 'Indirizzo',
    iban: 'IBAN per gli incassi',
    irpf: 'Ritenuta IRPF (%)',
    submit: 'Invia richiesta',
    pendingTitle: 'Richiesta in revisione',
    pendingDesc: 'Il nostro team sta verificando il suo account. La avviseremo via email una volta approvato.',
    pendingApproved: 'Il suo account è stato approvato!',
    checkStatus: 'Verifica di nuovo',
    profileErrorTitle: 'Impossibile caricare il suo profilo',
    profileErrorDesc:
      'La sua sessione è valida ma non troviamo i dati del suo account. Riprovi o esca.',
    rejectedTitle: 'Richiesta rifiutata',
    rejectedDesc: 'La sua richiesta non è stata approvata. Motivo: {{reason}}',
    loginPrompt: 'Ha già un account? Accedi',
    registerPrompt: 'Non ha un account? Registrati',
    login: 'Accedi',
    magicLink: 'Invia link magico',
    magicLinkSent:
      'Le abbiamo inviato un link magico alla sua email. Lo apra per accedere.',
    cifInvalid: 'CIF non valido',
    cifInRegistry: 'Trovata nell\'elenco',
    nifOrCifInvalid: 'NIF/CIF non valido',
    ibanInvalid: 'IBAN non valido',
    irpfRange: 'Deve essere compreso tra 7 e 45 %',
    loginErrorGeneric: 'Impossibile accedere. Controlli l\'email.',
    loginRateLimited: 'Troppi tentativi. Attenda un minuto.',
    loginEmailNotConfirmed: 'Confermi la sua email prima di accedere.',
  },
  admin: {
    approvalsTitle: 'Coda di approvazione',
    approve: 'Approva',
    reject: 'Rifiuta',
    reason: 'Motivo',
    empty: 'Nessuna richiesta in attesa',
    typeCompany: 'Azienda',
    typeAutonomo: 'Autonomo',
    typeOwner: 'Proprietario',
    approvedToast: 'Richiesta approvata',
    rejectedToast: 'Richiesta rifiutata',
    decisionFailed: 'Impossibile salvare la decisione',
    searchPlaceholder: 'Cerca per nome, email o NIF/CIF',
    tabAll: 'Tutte',
    tabCompany: 'Aziende',
    tabAutonomo: 'Autonomi',
    tabOwner: 'Proprietari',
    confirmApprove: 'Approvare {{name}}?',
    confirmReject: 'Rifiutare {{name}}?',
    confirm: 'Conferma',
    reasonRequired: 'Indichi il motivo del rifiuto',
    noMatches: 'Nessun risultato',
    roleAdmin: 'Amministrazione',
    consoleTitle: 'Console di amministrazione',
    navApprovals: 'Approvazioni',
    navAccounts: 'Conti',
    navBookings: 'Prenotazioni',
    navInvoices: 'Fatture',
    tabAgency: 'Agenzie',
    tabEmployee: 'Dipendenti',
    tabBlocked: 'Bloccati',
    typeAgency: 'Agenzia',
    typeEmployee: 'Dipendente',
    typeAdmin: 'Admin',
    typeSuperadmin: 'Superadmin',
    statusPending: 'In attesa',
    active: 'Attivo',
    blocked: 'Bloccato',
    rejected: 'Rifiutato',
    block: 'Blocca',
    unblock: 'Sblocca',
    blockedToast: 'Account bloccato',
    unblockedToast: 'Account sbloccato',
    manageFailed: "Impossibile cambiare lo stato dell'account",
    commissionDefault: 'Predefinito {{pct}}%',
    commissionEdit: 'Modifica',
    commissionSave: 'Salva',
    commissionCancel: 'Annulla',
    commissionSaved: 'Commissione aggiornata.',
    commissionFailed: 'Impossibile aggiornare la commissione.',
    lastActions: '{{count}} azioni di amministrazione registrate',
    noBookings: 'Nessuna prenotazione.',
    noInvoices: 'Nessuna fattura.',
    kindCommission: 'Commissione',
    kindLodging: 'Alloggio',
    vfFiled: 'VeriFactu trasmessa',
    vfIncidence: 'Incidenza',
    vfPending: 'VeriFactu in attesa',
    navRegistry: 'Elenco',
    vfSubmit: 'Invia all\'AEAT',
    vfSubmitted: 'Inviata all\'AEAT',
    vfSubmitFailed: 'Invio all\'AEAT fallito',
    vfNotConfigured: 'Certificato VeriFactu non configurato',
    void: 'Annulla',
    voidConfirm: 'Annullare questa fattura? Se è stata trasmessa all\'AEAT, verrà inviato un annullamento.',
    voidDone: 'Fattura annullata',
    voidFailed: 'Impossibile annullare la fattura',
    voidAnulacionPending: 'Annullamento AEAT in attesa di certificato',
    voided: 'Annullata',
    rect: 'Rectificativa',
    rectConfirm: 'Emettere una rectificativa che sostituisca questa fattura?',
    rectDone: 'Rectificativa emessa',
    rectFailed: 'Impossibile emettere la rectificativa',
    registry: {
      addTitle: 'Aggiungi azienda',
      editTitle: 'Modifica azienda',
      listTitle: 'Elenco aziende',
      cif: 'CIF',
      legalName: 'Ragione sociale',
      street: 'Via',
      postalCode: 'CAP',
      city: 'Città',
      province: 'Provincia',
      country: 'Paese',
      save: 'Salva',
      saved: 'Azienda salvata',
      saveError: 'Impossibile salvare l\'azienda',
      deleted: 'Azienda rimossa',
      deleteError: 'Impossibile rimuovere l\'azienda',
      errFields: 'CIF e ragione sociale sono obbligatori',
      empty: 'Nessuna azienda nell\'elenco',
      edit: 'Modifica',
    },
  },
  dashboard: {
    roleLabel: 'Ruolo',
    emailLabel: 'Email',
  },
  notFound: {
    title: 'Pagina non trovata',
    desc: 'La pagina che cerca non esiste o ha cambiato indirizzo.',
  },
  error: {
    boundaryDesc: 'Qualcosa è andato storto. Ricarichi per continuare.',
    boundaryReload: 'Ricarica',
  },
  common: {
    loading: 'Caricamento…',
    error: 'Si è verificato un errore',
    favorite: 'Salva tra i preferiti',
    required: 'Obbligatorio',
    back: 'Indietro',
    retry: 'Riprova',
    continue: 'Continua',
    done: 'Fatto',
    save: 'Salva',
    plusIva: '+ IVA',
    cancel: 'Annulla',
    rooms: 'camere da letto',
    room: 'camera da letto',
    bathrooms: 'bagni',
    bathroom: 'bagno',
    increment: 'Aumenta',
    decrement: 'Riduci',
    edit: 'Modifica',
    close: "Chiudi",
    previous: 'Precedente',
    next: 'Successivo',
  },
  amenities: {
    wifi: 'Wi-Fi',
    parking: 'Parcheggio',
    ac: 'Aria condizionata',
    heating: 'Riscaldamento',
    washing: 'Lavatrice',
    dishwasher: 'Lavastoviglie',
    elevator: 'Ascensore',
    furnished: 'Arredato',
    kitchen: 'Cucina',
    meeting_room: 'Sala riunioni',
    printer: 'Stampante',
    gym: 'Palestra',
  },
} as const